// extracted by mini-css-extract-plugin
export default {"gsa-react-tabs__tab--selected":"Filters_gsa-react-tabs__tab--selected__xxMqU"};